import React from 'react'
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Label,
} from "recharts";

export default function Chart({ chartData }) {

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-black border border-gray-700 p-3 rounded text-white text-xs">
                    <div className="flex gap-4">
                        <div>
                            <span className="text-zinc-400">VALUE</span>
                            <div className={`text-lg font-bold ${payload[0].value > 0 ? 'text-secondary' : 'text-red-600'}`}>{payload[0].value > 0 ? '+' : ''}{payload[0].value}</div>
                        </div>
                        <div>
                            <span className="text-zinc-400">DATE</span>
                            <div className="font-bold  text-lg text-white">{label}</div>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };
    return (
        <div>
            <ResponsiveContainer width="100%" height={350}>
                <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                    <XAxis dataKey="date" stroke="#ccc"
                        style={{ fontSize: "12px" }}
                    >
                        <Label value="Month" offset={-5} position="insideBottom" fill="#ccc"
                            style={{ fontSize: "12px" }}
                        />
                    </XAxis>
                    <YAxis stroke="#ccc"
                        style={{ fontSize: "12px" }}
                    >
                        <Label
                            value="Value ($)"
                            angle={-90}
                            position="insideLeft"
                            style={{ textAnchor: 'middle', fontSize: "12px" }}
                            fill="#ccc"
                        />
                    </YAxis>
                    <YAxis stroke="#ccc" />
                    <Tooltip
                        content={<CustomTooltip />}
                        labelStyle={{ color: "white" }}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#3b82f6"
                        strokeWidth={2}
                        dot={{ r: 4 }}
                        activeDot={{ r: 6 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}
